import { Report56Component } from "../../../components/SupportSystem/Reports/Report56Component";
// import { Report56NewComponent } from "../../../components/SupportSystem/Reports/Report56NewComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function Report56Container() {
    const titleName = "หน่วยงานที่อนุมัติให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน";
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <Report56Component />
            {/* <Report56NewComponent /> */}
            <Footer />
        </div>
        // 
    )

}